import React from "react";
import { FormControl, FormGroup, FormLabel } from "react-bootstrap";
import Select from "react-select";

import "../styles.css";

const MultipleSelect = ({
  id,
  label,
  options,
  isClearable = false,
  isSearchable = false,
  width = "15%",
  onSelectChange,
  placeholder = "",
  value,
  isForm = false,
  errorText = "",
}) => {
  const handleSelect = (e) => {
    onSelectChange(id, e);
  };

  return (
    <div style={{ width: width }} className={isForm ? "multiple-select-input-form" : ""}>
      <FormGroup>
        {!isForm && (
          <FormLabel htmlFor={`input-select-${id}`}>{label}</FormLabel>
        )}
        <Select
          classNamePrefix="select"
          isClearable={isClearable}
          isSearchable={isSearchable}
          id={`input-select-${id}`}
          name={id}
          options={options ? options : []}
          onChange={handleSelect}
          value={value}
          placeholder={placeholder}
          className={Boolean(errorText) && "multiple-select-error-input"}
        />
        {Boolean(errorText) && (
          <FormControl.Feedback type="invalid" style={{ display: "block" }}>
            {errorText}
          </FormControl.Feedback>
        )}
      </FormGroup>
    </div>
  );
};

export default MultipleSelect;
